import { billsTableColumnDefinitions } from '../constants/billsTableColumnDefinitions'
import { BillsTableSortKey } from '../types/billsTableSortKey'

const billsTableSortableKeys = new Set<string>(
  billsTableColumnDefinitions.filter((column) => 'sortable' in column && column.sortable).map((column) => column.key),
)

export const isBillsTableSortKey = (key: string): key is BillsTableSortKey => billsTableSortableKeys.has(key)
